<label class="ap-switch" data-testid="label">
    <input
        data-testid="input"
        class="ap-switch__input"
        [ngClass]="{ 'ap-switch__input--non-interactive': nonInteractive() }"
        type="checkbox"
        role="switch"
        [attr.aria-label]="label()"
        [attr.aria-describedby]="control && control.invalid ? uniqueId + '-errors' : null"
        [attr.aria-invalid]="control ? control.invalid : null"
        [attr.disabled]="isDisabled ? isDisabled : null"
        [attr.checked]="isChecked ? isChecked : null"
        (change)="switchChange($event)"
    />
    <!-- The following are disabled because the parent <label> triggers a click event on both hidden input and visible span. ESLint issues don't apply because they really are handled by the <label> element itself (we stop event propagation on the span). -->
    <!-- eslint-disable @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <span class="ap-switch__slider" (click)="onSliderClick($event)">
        <span class="ap-switch__slider-button" data-testid="button"></span>
    </span>
</label>

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}
